/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  followRequest: ["userId", "user2Id"],
  followSuccess: ["response"],
  followFailure: ["response"],
  unfollowRequest: ["userId", "user2Id"],
  unfollowSuccess: ["response"],
  unfollowFailure: ["response"],
  whoFollowMeRequest :null

})

export const FollowTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  userId: null,
  user2Id: null,
  following: null,
  updating: null,
  updateCounter: 0, // quick way to tell if a page needs to check and update it's local data
  error: null
})

/* ------------- Reducers ------------- */

// follow user
export const followRequest = (state, action) => {
  console.tron.display({
    name: 'followRequest',
    preview: 'action',
    value: {
      state: state,
      action: action
    }
  })
  const { userId, user2Id } = action
  console.tron.display({
    name: 'followRequest2',
    preview: 'userId',
    value: {
      userId: userId,
      user2Id: user2Id
    }
  })
  return state.merge({ updating: true, error: null, userId: userId, user2Id: user2Id })
}
export const whoFollowMeRequest = (state, action) => {

  return state.merge({ updating: true, userId: null, user2Id: null })
}

// successful follow user
export const followSuccess = (state, action) => {
  console.tron.display({
    name: 'followSuccess1',
    preview: 'You should totally expand this',
    value: {
      action: action
    }
  })
  const { response } = action
  const { data } = response
  const apiResponse = data


  return state.merge({ updating: false, updateCounter: state.updateCounter+1, following: true }) // TODO - check the apiResponse
}

// failed follow user
export const followFailure = (state, action) => {
  const { response } = action
  console.tron.display({
    name: 'followFailure',
    preview: 'You should totally expand this',
    value: {
      state: state,
      action: action,
      response: response,
    }
  })
  const error = response.data.errors ? response.data.errors[0] : true
  return state.merge({ updating: false, error: error })
}


// unfollow user
export const unfollowRequest = (state, action) => {
  console.tron.display({
    name: 'unfollowRequest',
    preview: 'action',
    value: {
      state: state,
      action: action
    }
  })
  const { userId, user2Id } = action
  console.tron.display({
    name: 'updateRequest2',
    preview: 'userChanges',
    value: {
      userId: userId,
      user2Id: user2Id
    }
  })
  return state.merge({ updating: true, userId: userId, user2Id: user2Id })
}

// successful unfollow user
export const unfollowSuccess = (state, action) => {
  const { response } = action
  const { data } = response
  const apiResponse = data
  // const user = apiResponse.data[0]
  console.tron.display({
    name: 'unfollowSuccess',
    preview: 'You should totally expand this',
    value: {
      action: action,
      response: response,
      apiResponse: apiResponse
    }
  })
  return state.merge({ updating: false, updateCounter: state.updateCounter+1, following: false })
}

// failed unfollow user
export const unfollowFailure = (state, action) => {
  const { response } = action
  console.tron.display({
    name: 'unfollowFailure',
    preview: 'You should totally expand this',
    value: {
      state: state,
      action: action,
      response: response,
    }
  })
  // const error = response.data.errors ? response.data.errors[0] : true
  return state.merge({ updating: false, error: error })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.FOLLOW_REQUEST]: followRequest,
  [Types.FOLLOW_SUCCESS]: followSuccess,
  [Types.FOLLOW_FAILURE]: followFailure,
  [Types.UNFOLLOW_REQUEST]: unfollowRequest,
  [Types.UNFOLLOW_SUCCESS]: unfollowSuccess,
  [Types.UNFOLLOW_FAILURE]: unfollowFailure,
  [Types.WHO_FOLLOW_ME_REQUEST]: whoFollowMeRequest
})
